var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayout4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 147,
    viewBox: "0 0 183 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 182.173,
    height: 147,
    rx: 2,
    fill: "#F4F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 19,
    width: 45,
    height: 21,
    rx: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 42,
    width: 45,
    height: 21,
    rx: 4,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 65,
    width: 45,
    height: 21,
    rx: 4,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 88,
    width: 128,
    height: 21,
    rx: 4,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 79,
    height: 67,
    rx: 4,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2793,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#6D788C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5054,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 92.0732,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 124.299,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3478_2933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.53 35C62.8371 35 73.1446 35 83.4517 35C83.5498 35.0249 83.6478 35.0497 83.7458 35.0751C85.0603 35.4105 85.9976 36.5974 85.9976 37.9545C86 47.9792 86.0005 58.0034 85.9976 68.0281C85.9972 69.6611 84.6606 70.9977 83.0281 70.9981C73.0034 71.0014 62.9792 70.9995 52.9545 71C52.4183 71 51.9201 70.8597 51.4622 70.5853C50.6502 70.0984 50.182 69.3722 49.9995 68.4517V37.53C50.0825 37.1636 50.1872 36.8057 50.3823 36.4801C50.8744 35.6615 51.6016 35.1848 52.53 35ZM53.0164 58.3013C53.1253 58.1981 53.182 58.146 53.2365 58.0916C54.4018 56.9268 55.5661 55.7615 56.7324 54.5976C56.8595 54.4709 56.9885 54.3443 57.1292 54.2345C58.3527 53.2808 60.0172 53.3774 61.1412 54.4841C62.3539 55.6785 63.5506 56.8888 64.7548 58.0926C64.9131 58.2508 65.0687 58.2535 65.2216 58.1005C66.3315 56.9911 67.4415 55.8811 68.551 54.7712C70.1249 53.1977 71.7007 51.6262 73.2708 50.049C73.9037 49.4138 74.6575 49.0713 75.5564 49.0906C76.4008 49.1089 77.1068 49.4504 77.7017 50.0476C79.3821 51.735 81.0681 53.4168 82.7537 55.0996C82.8085 55.1544 82.8508 55.2365 82.9643 55.2441V54.9973C82.9643 49.4532 82.9643 43.9096 82.9643 38.3655C82.9643 38.1331 82.8472 38.0166 82.6129 38.016C72.8683 38.016 63.1232 38.016 53.3786 38.016C53.1372 38.016 53.0163 38.1366 53.016 38.3777C53.016 44.913 53.016 51.4488 53.016 57.9842C53.016 58.0677 53.016 58.1517 53.016 58.3009L53.0164 58.3013ZM67.9791 67.9653C72.8509 67.9653 77.7232 67.9653 82.5951 67.9653C82.8415 67.9653 82.9649 67.8394 82.9652 67.5876C82.9652 65.0346 82.9629 62.4812 82.969 59.9282C82.9694 59.7167 82.908 59.5642 82.7579 59.4141C80.4019 57.0661 78.0516 54.713 75.6995 52.3613C75.5584 52.2202 75.4138 52.2237 75.2655 52.3716C73.1732 54.4639 71.0809 56.5567 68.9882 58.6485C68.3478 59.2888 67.7136 59.9357 67.062 60.5648C66.499 61.1086 65.8103 61.3816 65.0288 61.3891C64.1482 61.398 63.4061 61.0621 62.7864 60.4396C61.5906 59.2391 60.3892 58.0447 59.1957 56.8419C59.0526 56.6979 58.9677 56.6664 58.8049 56.8302C56.9392 58.7076 55.0665 60.578 53.1919 62.4465C53.0657 62.5722 53.0122 62.7012 53.0132 62.8795C53.0188 64.4487 53.0164 66.0184 53.0164 67.5876C53.0164 67.8394 53.1397 67.9653 53.3861 67.9653C58.2504 67.9653 63.1143 67.9653 67.9786 67.9653H67.9791Z",
    fill: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7593 43.9775C64.026 43.9799 65.0144 44.9871 65.0097 46.2716C65.0055 47.5241 63.9974 48.513 62.7279 48.5107C61.4618 48.5083 60.4724 47.5002 60.4771 46.2167C60.4813 44.965 61.4904 43.9752 62.7593 43.9775Z",
    fill: "#E5E6E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3478_2933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(50 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout4);
export default __webpack_public_path__ + "static/media/layout4.dedc9ea789cde616d84f764896518713.svg";
export { ForwardRef as ReactComponent };